import React, { useState } from "react";
import { Box, Button, FormControl, FormLabel, Input, Alert } from "@mui/joy";
import { useAuthStore } from "../../store/authStore";

interface EmailSignUpFormProps {}

export const EmailSignUpForm: React.FC<EmailSignUpFormProps> = () => {
  const { signUp, loading } = useAuthStore();
  const [formData, setFormData] = useState({
    email: "",
    password: "",
    fullName: "",
  });
  const [error, setError] = useState("");
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");

    if (formData.password.length < 6) {
      setError("Password must be at least 6 characters");
      return;
    }

    try {
      await signUp(
        formData.email,
        formData.password,
        null, // Username will be set later
        formData.fullName,
      );
      setSuccess(true);
    } catch (err) {
      setError((err as Error).message);
    }
  };

  if (success) {
    return (
      <Box>
        <Alert color="success" sx={{ mb: 3 }}>
          <span>
            We've sent a confirmation email to <strong>{formData.email}</strong>
            . Please check your inbox and click the link to activate your
            account.
          </span>
        </Alert>
      </Box>
    );
  }

  return (
    <Box component="form" onSubmit={handleSubmit} sx={{ textAlign: "left" }}>
      {error && (
        <Alert color="danger" sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <FormControl sx={{ mb: 2 }}>
        <FormLabel>Full Name</FormLabel>
        <Input
          required
          placeholder="Your name"
          value={formData.fullName}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, fullName: e.target.value }))
          }
        />
      </FormControl>

      <FormControl sx={{ mb: 2 }}>
        <FormLabel>Email</FormLabel>
        <Input
          type="email"
          required
          placeholder="Your email"
          value={formData.email}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, email: e.target.value }))
          }
        />
      </FormControl>

      <FormControl sx={{ mb: 3 }}>
        <FormLabel>Password</FormLabel>
        <Input
          type="password"
          required
          placeholder="At least 6 characters"
          value={formData.password}
          onChange={(e) =>
            setFormData((prev) => ({ ...prev, password: e.target.value }))
          }
        />
      </FormControl>

      <Button
        type="submit"
        fullWidth
        loading={loading}
        sx={{
          backgroundColor: "#FF6B4A",
          "&:hover": { backgroundColor: "#E55A3A" },
        }}
      >
        Create Account
      </Button>
    </Box>
  );
};
